/* TENDS · Textos de Judge.me que la app deja en inglés, y nombre genérico
   "Cliente" en lugar de "Cliente Amazon" (la web no menciona otros canales). */
(function () {
  var MAP = { 'Write a review': 'Escribir una reseña', 'Cancel review': 'Cancelar', 'Submit Review': 'Enviar reseña', 'Ask a question': 'Hacer una pregunta' };
  function fix(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue.trim();
      if (!t) continue;
      if (MAP[t]) n.nodeValue = n.nodeValue.replace(t, MAP[t]);
      else if (t === 'Cliente Amazon' && n.parentElement && /jdgm/.test(n.parentElement.className)) n.nodeValue = n.nodeValue.replace(t, 'Cliente');
    }
  }
  function run() {
    document.querySelectorAll('[class*="jdgm"]').forEach(function (el) { if (!el.closest('[class*="jdgm"] [class*="jdgm"]')) fix(el); });
  }
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(run, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
